import { createTheme } from "@mui/material";

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

export const LOG_STREAM_THEME = createTheme({
  typography: {
    fontFamily: ["JetBrains Mono", "sans-serif"].join(","),
  },
});
